import type { labelProviderInterface } from '../../../../LabelProviderInterface';

let ctaIndentifier;
let ctaText;

export const setButtonText = (
  labelProvider: labelProviderInterface,
  updateCta: (ctaText: string, ctaIndentifier: string) => void
) => {
    const buttonTextFallbacks = ['Back', 'Back to Search', 'Back to Homepage'];
    const buttonText = [
      labelProvider('conversational.search.navigator.back.general', buttonTextFallbacks[0]),
      labelProvider('conversational.search.navigator.back.to.srp', buttonTextFallbacks[1]),
    ];

    // Not in media utils as it is very GenAI specific case
    const isMediumLargeDesktop = window.innerWidth <= 1280;

    if (isMediumLargeDesktop) {
      ctaText = buttonText[0];
      ctaIndentifier = buttonTextFallbacks[0];
    } else {
      ctaText = buttonText[1];
      ctaIndentifier = 'Back to Search';
    }

    updateCta(ctaText, ctaIndentifier);
};
